import {type ForwardedRef, forwardRef} from 'react';
import {cn} from '../../../../../lib/classname';
import {CommonLink} from '../../../../../shared/components/CommonLink';
import {COLUMNS_BY_TAG} from '../routes';

type Props = {
  name: string;
  className?: string;
};

export const ColumnCardTag = forwardRef<HTMLAnchorElement, Props>(
  ({name, className}, ref: ForwardedRef<HTMLAnchorElement>) => {
    return (
      <CommonLink
        ref={ref}
        href={COLUMNS_BY_TAG(name)}
        className={cn(
          'text-black-2 text-[12px] leading-[18px] border border-black-2 rounded-16 px-8 py-4',
          'text-nowrap hover:opacity-60',
          className,
        )}
      >
        {name}
      </CommonLink>
    );
  },
);
